import React, { useState } from 'react';
import SafeIcon from '@/common/SafeIcon';

const NAV_LINKS = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Packages', href: '#packages' },
  { label: 'Terms', href: '#terms' },
  { label: 'Start Your Project', href: '#cta' },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (href) => {
    setIsOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav className="w-full flex items-center justify-between px-6 py-6 z-50 relative">
        <div className="text-white font-instrument italic text-xl sm:text-2xl tracking-wide select-none">
          SANS TITRE
        </div>
        
        {/* Desktop Nav */}
        <div className="hidden md:flex items-center liquid-glass rounded-full pl-6 pr-2 py-2">
          <div className="flex space-x-6 mr-6">
            {NAV_LINKS.map((link) => (
              <button 
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="text-white/90 text-sm hover:text-white transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>
          <button 
            onClick={() => scrollToSection('#packages')}
            className="bg-white text-black text-sm font-medium px-5 py-2 rounded-full hover:bg-white/90 transition-colors"
          >
            Book Intro Rate &rarr;
          </button>
        </div>

        {/* Mobile Nav Toggle */}
        <button 
          className="md:hidden liquid-glass w-12 h-12 rounded-full flex items-center justify-center text-white z-50 relative"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="relative w-6 h-6 flex items-center justify-center">
            <SafeIcon 
              name="Menu" 
              className={`absolute transition-all duration-300 ease-in-out ${isOpen ? 'rotate-90 scale-75 opacity-0' : 'rotate-0 scale-100 opacity-100'}`} 
              size={24} 
            />
            <SafeIcon 
              name="X" 
              className={`absolute transition-all duration-300 ease-in-out ${isOpen ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-75 opacity-0'}`} 
              size={24} 
            />
          </div>
        </button>
      </nav>

      {/* Mobile Menu Overlay */}
      <div 
        className={`fixed inset-0 z-40 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="flex flex-col items-center space-y-8">
          {NAV_LINKS.map((link, index) => (
            <button
              key={link.label}
              onClick={() => scrollToSection(link.href)}
              className="text-white text-3xl font-medium transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]"
              style={{
                transitionDelay: isOpen ? `${100 + index * 50}ms` : '0ms',
                transform: isOpen ? 'translateY(0)' : 'translateY(16px)',
                opacity: isOpen ? 1 : 0
              }}
            >
              {link.label}
            </button>
          ))}
          <button 
            onClick={() => scrollToSection('#packages')}
            className="mt-8 bg-white text-black text-lg font-medium px-8 py-4 rounded-full transition-all duration-500 delay-300 ease-[cubic-bezier(0.4,0,0.2,1)]"
            style={{
              transform: isOpen ? 'scale(1)' : 'scale(0.9)',
              opacity: isOpen ? 1 : 0
            }}
          >
            Book Intro Rate &rarr;
          </button>
        </div>
      </div>
    </>
  );
}